import { render, staticRenderFns } from "./card-row.vue?vue&type=template&id=1bac02d2&scoped=true"
import script from "./card-row.vue?vue&type=script&lang=js"
export * from "./card-row.vue?vue&type=script&lang=js"
import style0 from "./card-row.vue?vue&type=style&index=0&id=1bac02d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac02d2",
  null
  
)

export default component.exports